// removed by extract-text-webpack-plugin
module.exports = {"custom_col_2":"Balance__custom_col_2___2_To1","custom_col_3":"Balance__custom_col_3___18YGS","table":"Balance__table___1ZDtL","price":"Balance__price___3mV1g"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/User/Balance.scss
 ** module id = 1380
 ** module chunks = 0
 **/